import { toast } from "sonner";
import { Copy, Mail, MessageCircle, Smartphone } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export function InviteReview({ b }) {
  const link = `${window.location.origin}/entreprise/${b.id}?noter=1&invitation=${b.invite_token || ""}`;
  const text = `Bonjour, merci d'avoir fait appel à ${b.name}. Votre avis compte : pouvez-vous noter notre intervention ? ${link}`;
  const enc = encodeURIComponent(text);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      toast.success("Lien copié");
    } catch (e) {
      toast.error("Copie impossible, sélectionnez le lien manuellement");
    }
  };
  const share = [
    ["Email", Mail, `mailto:?subject=${encodeURIComponent(`Votre avis sur ${b.name}`)}&body=${enc}`, "invite-email-link"],
    ["SMS", Smartphone, `sms:?&body=${enc}`, "invite-sms-link"],
    ["WhatsApp", MessageCircle, `https://wa.me/?text=${enc}`, "invite-whatsapp-link"],
  ];
  return (
    <div className="space-y-3 rounded-xl border border-[#1E40AF] bg-[#EFF6FF] p-5" data-testid="invite-review">
      <p className="font-semibold text-slate-900">Invitez vos clients à noter votre intervention</p>
      <p className="text-sm text-slate-600">Envoyez ce lien après chaque intervention : il ouvre directement le formulaire d'avis, et l'avis déposé sera affiché comme « Avis vérifié ».</p>
      <div className="flex gap-2">
        <Input readOnly value={link} onFocus={(e) => e.target.select()} className="bg-white font-mono-id text-xs" data-testid="invite-link-input" />
        <Button onClick={copy} className="shrink-0 gap-1 bg-[#1E40AF] hover:bg-[#1D4ED8] hover:text-white" data-testid="invite-copy-button"><Copy className="h-4 w-4" />Copier</Button>
      </div>
      <div className="flex flex-wrap gap-2">
        {share.map(([label, Icon, href, testid]) => (
          <a key={label} href={href} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 rounded-full border border-slate-300 bg-white px-4 py-2 text-sm font-semibold text-slate-700 hover:border-[#1E40AF] hover:text-[#1E40AF]" data-testid={testid}>
            <Icon className="h-4 w-4" />{label}
          </a>
        ))}
      </div>
    </div>
  );
}
